import PayersFilterBar from '../PayersFilterBar/PayersFilterBar';
import PayersList from '../PayersList';

import PayersHeader from './PayersHeader';
import PayersLayout from './PayersLayout';
import usePayersReport from './hooks';

const PayersPage = () => {
  const { payersReports, isLoading } = usePayersReport();

  return (
    <PayersLayout>
      <div>
        <PayersHeader />
        <PayersFilterBar />
      </div>
      <PayersList payersReports={payersReports} loading={isLoading} />
    </PayersLayout>
  );
};

export default PayersPage;
